import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function patchAfterSalesExtra(id, data) {
  return getAPIResponse(`/v1/after-sales-extras/${id}`, data, 'PATCH');
}